import { Theme } from '@radix-ui/themes';
import { Main } from 'components/main';
import { AuthProvider } from 'contexts/auth';
import 'index.scss';
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom/client';
import reportWebVitals from 'reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Theme
      style={{
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      }}
      appearance="dark"
      accentColor="indigo"
      grayColor="auto"
      radius="small"
    >
      <CookiesProvider>
        <AuthProvider>
          <Main />
        </AuthProvider>
      </CookiesProvider>
    </Theme>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
